// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__kFSVh","loading":"Loading_loading__sC-zD","primary":"Loading_primary__C4ZSk","danger":"Loading_danger__3vy6A","default":"Loading_default__ah--5"};